import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    return (
        localStorage.getItem('access_token') ? <Outlet /> : <Navigate replace to="/signin" />
    );
};

export default ProtectedRoute;